export default "__VITE_ASSET__BHKbDARO__"